import { useGetFeatureFlags } from '@/hooks/api/tenants/useGetFeatureFlags';
import { useTenants } from '@/services/tenants/useTenants';
import { ReactNode, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { FeatureFlagsContext } from './FeatureFlagsContext';

const getUrlTenantShortName = (pathname: string) => /^\/tenants\/([^/]+)/.exec(pathname)?.[1];

export const FeatureFlagsProvider = ({ children }: { children: ReactNode }) => {
  const { tenant, getTenantId } = useTenants();
  const tenantId = getTenantId();
  const urlTenantShortName = getUrlTenantShortName(useLocation().pathname);
  const areFlagsForUrlTenant = !urlTenantShortName || urlTenantShortName === tenant?.tenantShortName;

  const { featureFlags, isFeatureEnabled, isFetching, error, refetch } = useGetFeatureFlags(tenantId);
  const areFeatureFlagsLoaded = featureFlags !== undefined && areFlagsForUrlTenant;
  const didFeatureFlagsFail = !areFeatureFlagsLoaded && Boolean(error) && !isFetching;

  const contextValue = useMemo(
    () => ({
      isFeatureEnabled,
      areFeatureFlagsLoaded,
      didFeatureFlagsFail,
      retryFeatureFlags: () => void refetch(),
    }),
    [isFeatureEnabled, areFeatureFlagsLoaded, didFeatureFlagsFail, refetch]
  );

  return <FeatureFlagsContext.Provider value={contextValue}>{children}</FeatureFlagsContext.Provider>;
};
